import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bankAccountsApi from '@/features/dashboard/paymentConfig/api/bankAccountsApi.ts';
import { bankAccountsApiQueryKeys } from '@/features/dashboard/paymentConfig/api/bankAccountsApi.queryKeys.ts';
import { BankAccountDto } from '@/features/dashboard/paymentConfig/types/BankAccountDto.ts';

const useGetBankAccounts = () => {
  return useQuery(getBankAccountsQueryOptions());
};

export const getBankAccountsQueryOptions = (): UseQueryOptions<
  BankAccountDto[]
> => ({
  queryKey: bankAccountsApiQueryKeys.all(),
  queryFn: () => bankAccountsApi.getAll(),
  staleTime: 1000 * 60,
});

export default useGetBankAccounts;
